// extracted by mini-css-extract-plugin
module.exports = {"figure":"_3nsjP"};